module.exports = __webpack_public_path__ + "img/ship.2faba2f3.svg";